(function (processAccelerator, $) {
    /* Initialize refresh button */
    processAccelerator.InitRefreshButton = function () {
        /* Synchronise process accelerators with Profit  */
        $(document).on("click",
            "[data-synchronize-processaccelerators]",
            function () {
                $.ajax({
                    url: "/ProcessAccelerator/SynchronizeWithProfit",
                    dataType: "json",
                    complete: function (data) {
                        var alert = $("#alert-template").text();
                        if (data.responseJSON.success) {
                            alert = globalCore.TemplateReplace(alert, "alertType", "success");
                            alert = globalCore.TemplateReplace(alert, "alertMessage", "De synchronisatie met Profit is gestart.");
                        } else {
                            alert = globalCore.TemplateReplace(alert, "alertType", "danger");
                            alert = globalCore.TemplateReplace(alert, "alertMessage", "Het synchroniseren van een of meer processversnellers is mislukt.");
                        }
                        var container = $("#sync-alert-container");
                        container.prepend(alert).alert();
                        window.setTimeout(function () { container.find("#alert-sync").alert('close'); }, 3000);
                    }
                });
            });
    }
}(window.processAccelerator = window.processAccelerator || {}, $));
